export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lighttextDesc: true,
  topLine: "Preradili ste svoje vozilo i više nije legalno?",
  headline: "Prepustite nam svu brigu oko atestiranja vašeg vozila.",
  description:
    "Atest Shop Croatia nudi svojim klijentima izradu tehničkog elaborata za sva nezakonski prerađena vozila. Tijekom procesa, klijentima će biti dostupan svaki koristan savjet i/ili informacija u vezi pripreme vozila za atest.",
  buttonLabel: "Saznaj više",
  imgStart: false,
  img: require("../../images/car-1.svg").default,
  alt: "Automobil",
  dark: true,
  primary: true,
  darkText: false,
};
